import * as React from "react";
import { StoredProcedure, StoredUser, useQueryParams } from "duck";
import { Filter } from "./types";
import { getFilter, getMissingIds } from "./utils";

export const useOptions = <TFilter extends Filter>(
  getOptions: any,
  filterType: TFilter
): {
  options: typeof filterType extends "doctors"
    ? StoredUser[]
    : StoredProcedure[];
  ids: typeof filterType extends "doctors" ? number[] : string[];
} => {
  const [params] = useQueryParams();
  const [options, setOptions] = React.useState<any[]>([]);

  const result = React.useMemo(() => {
    const { ids } = getFilter(params.filter, filterType);
    const missingIds = getMissingIds(ids, options);
    return { ids, missingIds };
  }, [params.filter, filterType, options]);

  React.useEffect(() => {
    if (result.missingIds.length === 0) {
      return;
    }

    getOptions({ ids: result.missingIds }).then(({ collection }: any) => {
      if (result.missingIds.length === result.ids.length) {
        setOptions(collection);
      } else {
        setOptions(prev => [...prev, ...collection]);
      }
    });
  }, [result.missingIds]);

  return { options, ids: result.ids };
};
